<template>
  <div class="testimonal-section">
    <rich-text class="testimonal-section__copy" :textData="data.copy" />
    <p class="testimonal-section__name">{{data.testimonialName}}</p>
    <p class="testimonal-section__company-job">{{data.companyJob}}</p>
  </div>
</template>

<script>
import RichText from './RichText.vue';

export default {
  props: ['data'],
  components: { RichText },
};
</script>

<style>
.testimonal-section {
  margin: 60px auto 0;
  padding: 0 60px 48px 60px;
  text-align: center;
  max-width: 816px;

  border-bottom: 3px solid var(--very-light);
}

.testimonal-section__copy {
  font-size: 24px;
  font-style: italic;
  font-weight: lighter;
}

.testimonal-section__name,
.testimonal-section__company-job {
  text-align: right;
  font-family: var(--headline-font);
}

.testimonal-section__name {
  font-size: 24px;
  margin-bottom: 0;
  line-height: 1;
}

.testimonal-section__company-job {
  margin-top: 8px;
  line-height: 1;
}
</style>s
